import React from 'react';
import Modal from "../../../../components/Modal";

const ContinueTableNumber = ({
    open,
    onClose,
    onContinue,
    onChangeTable,
    tableNumber,
}) => {
    return (
        <Modal
            isOpen={open}
            onClose={onClose}
        >

            <div className="p-4 pb-6">
                <h2 className="text-xl font-semibold mb-2">
                    Lanjut pesan di meja ini?
                </h2>

                <p className="text-sm text-gray-600 mb-6">
                    Kami melihat kamu masih berada di Meja{' '}
                    <strong>{tableNumber}</strong>. Apakah kamu ingin
                    memesan menu tambahan untuk meja yang sama?
                </p>

                <div className='flex flex-row gap-3'>
                    <button
                        onClick={onContinue}
                        className="mt-4 w-full bg-[var(--rose-violet)] text-white text-sm font-semibold py-2 rounded-lg col-6"
                    >
                        Ya
                    </button>
                    <button onClick={onChangeTable} className="mt-4 w-full bg-[var(--rose-violet)] text-white text-sm font-semibold py-2 rounded-lg col-6">
                        Tidak, pindah meja
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ContinueTableNumber;